<style src="./SuggestProductDetails.scss" lang="scss"></style>
<template>
  <input-suggest
    :label="label"
    :placeholder="placeholder"
    @blur="blur"
    :rules="rules"
    v-model="inputValue"
    min="2">

    <input-suggest-item
      v-for="(item, idx) in suggestionList"
      :key="idx"
      :idx="idx"
      :item="item"
      class="client-item">

      <div class="client-row-top">
        <span class="lab">{{ item.lab }}</span>
        <span class="pativo">{{ item.pativo }}</span>
        <span class="comercialname">{{ item.comercialName }}</span>
      </div>

      <div class="stock-detail">
        <span class="label cost"><small>R$</small>{{ item.cost | CurrencyBR }}</span>
        <span class="label quantity"><small>QT</small>{{ item.stockQuantity | DecimalNumber }}</span>
        <span class="label date"><small>Últ. Comp</small>{{ item.lastBuyingDate | DateBR }}</span>
      </div>
    </input-suggest-item>
  </input-suggest>
</template>
<script>
import { InputSuggest, InputSuggestMixin, InputSuggestItem } from '@/components/primitives/input-suggest'
import { SearchStock } from '@/brain/record/stock'
import { CurrencyBR, DecimalNumber, DateBR } from '@/components/primitives/helpers/filters'

export default {
  name: 'SuggestProduct',
  mixins: [InputSuggestMixin],
  components: {
    InputSuggest,
    InputSuggestItem
  },
  data () {
    return {
      captionRaw: 'comercialName'
    }
  },
  filters: {
    CurrencyBR,
    DecimalNumber,
    DateBR
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    async doSearch (pSearchTerm) {
      const stock = await SearchStock({
        params: {
          skip: 0,
          limit: 15,
          filters: {
            searchText: pSearchTerm
          }
        }
      })

      return stock.list
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/suggest/suggest-product-details/SuggestProductDetails.vue